module.exports = __webpack_public_path__ + "img/available-on-the-app-store.ea3693a5.svg";